import React from 'react';
import './OverwriteProjectDialog.css';

interface OverwriteProjectDialogProps {
  projectName: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  onContinueWithOld: () => void;
}

const OverwriteProjectDialog: React.FC<OverwriteProjectDialogProps> = ({
  projectName,
  message,
  onConfirm,
  onCancel,
  onContinueWithOld,
}) => {
  return (
    <div className="overwrite-dialog-overlay">
      <div className="overwrite-dialog">
        <div className="overwrite-dialog-header">
          <h2>Project Already Exists</h2>
        </div>
        <div className="overwrite-dialog-content">
          <p>{message}</p>
          <p className="overwrite-warning">
            ⚠️ Warning: Overwrite will permanently delete the existing project and all its files.
          </p>
          <p className="overwrite-info">
            ℹ️ Continue with old data will use the existing project files without uploading new data.
          </p>
        </div>
        <div className="overwrite-dialog-actions">
          <button
            className="overwrite-btn cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="overwrite-btn continue-btn"
            onClick={onContinueWithOld}
          >
            Continue with Old Data
          </button>
          <button
            className="overwrite-btn confirm-btn"
            onClick={onConfirm}
          >
            Overwrite
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverwriteProjectDialog;

